angular
  .module('survey')
  .factory('submissionHandler', ['$http', submissionHandler]);

function submissionHandler($http) {
  return {
    submit: function (config) {
      // If we have a submission ID, submit these values with that ID so our answers are linked
      var url = `/api/submit/${config.submissionId}`;
      if (config.done) {
        url += '?done=1';
      }
      return $http.post(url, {
        page: config.page,
        email: config.email,
        cell_phone: config.cell_phone,
        code: config.code,
        survey_variant_id: config.survey_variant_id,
        values: config.values,
        url: config.url,
      });
    },
  };
}
